import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import config from '../../config'
import { orderBy } from 'lodash' // chain
import CSSModules from 'react-css-modules'
import Loader from 'react-loader'
import ReactTooltip from 'react-tooltip'
import container from '../../helpers/container'
import format from '../../helpers/format'
// import convert from '../../helpers/convert'
import analytics from '../../helpers/analytics'
import {
  ContainerDivs,
  Chart,
  Link,
  LinkIcon,
  FamilyGrid,
  // GenderEqualityScoreLabel,
  Grade
} from '../../components'
import * as searchActions from 'redux/modules/search'
import Styles from './Family.css'


/**
 * <FundManagerFundList
 *   @param fundList {list} List of funds for this fund manager
 * />
 *
 * Displays a list of funds for this fund manager.
 * For each fund in fundList, displays a FamilyFundListItem component.
 *
 */
@CSSModules(Styles, {allowMultiple:true})
class FundManagerFundList extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { fundList } = this.props
    if (!fundList) { return null }

    return <div styleName='fund-list'>
      {
        fundList.map((fund, idx) => {
          return <FundManagerFundListItem
            fund={fund}
            key={'family-fund-list-item-'+idx}
          />
        })
      }
    </div>
  }
}


/**
 * <FundManagerFundListItem
 *   @param fund {object} A fund object
 * />
 *
 * Displays a fund in the list of funds for this mnanager. Displays summary
 * stats. Displays a list of tickers with FundManagerFundListItemTickerLinks
 * component.
 *
 */
@CSSModules(Styles, {allowMultiple:true})
class FundManagerFundListItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fund: props.fund || null
    }
  }

  render() {
    const { fund } = this.state
    if (!fund) { return null }

    // <div styleName='holding'>
    //   <div styleName='ticker-name-assets'>
    //     <div styleName='ticker-name'>
    //       <div styleName='holdings-name'>

    return <div styleName='fund-list-item'>

      <div styleName='fund-list-item__name-wrap'>
        <div styleName='fund-list-item__fund-name'>
          {fund.fund_legal_name}
        </div>
        <FundManagerFundListItemTickerLinks shareclasses={fund.shareclass} />
      </div>

      <div styleName='fund-list-item__grade-wraps'>
        <div styleName='fund-list-item__grade-wrap'>
          <span>Gender equality</span>
          <Grade grade={fund.grade_gender_equality} square/>
        </div>
        <div styleName='fund-list-item__grade-wrap'>
          <span>Diversity disclosures</span>
          <Grade grade={fund.grade_dei} square/>
        </div>
        <div styleName='fund-list-item__grade-wrap'>
          <span>Racial justice</span>
          <Grade grade={fund.grade_rji} square/>
        </div>
        <div styleName='fund-list-item__grade-wrap'>
          <span>LGBTQ+ equity</span>
          <Grade grade={fund.grade_hrc} square/>
        </div>

      </div>
    </div>
  }
}


/**
 * <FundManagerFundListItemTickerLinks
 *   @param shareclasses {list} List of shareclass objects
 * />
 *
 * Displays a list of tickers, linked to those shareclass profiles, for a fund
 * in the fund list. Maps a list of shareclasses to a list of URLs and
 * tickers. Maps the list of URLs and tickers to a list of Links.
 *
 */
@CSSModules(Styles, {allowMultiple:true})
class FundManagerFundListItemTickerLinks extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { shareclasses } = this.props
    if (!shareclasses) { return null }

    const tickerUrls = shareclasses.map((e,i)=>{
      const tckr = e.ticker || 'N/A'
      const safeTicker = e.ticker || 'N'
      const url = config.routes.fund + '/' +
        format.sanitize(e.fund_legal_name) + '/' + safeTicker + '/' +
        config.profilePath + '/' + e.fund_id + '/' + e.investment_vehicle_id

      return {
        ticker: tckr,
        name: e.name,
        url
      }
    })

    if (tickerUrls.length === 1 && tickerUrls[0].ticker === 'N/A') {
      const e = tickerUrls[0]
      return <div styleName='fund-list-item__tickers-wrap'>
        <Link to={e.url} title={e.name}>
          <span styleName='fund-list-item__ticker'>See results<LinkIcon/></span>
        </Link>
      </div>
    }

    return <div styleName='fund-list-item__tickers-wrap'>
      {
        tickerUrls.map((e, i)=>{
          return <Link
            key={'fund-list-item__ticker--'+i}
            to={e.url}
            title={e.name}
          >
            { e.ticker === 'N/A' ?
                <span styleName='fund-list-item__ticker'>{e.name}</span> :
                <span styleName='fund-list-item__ticker'>{e.ticker}</span>
            }
          </Link>
        })
      }
    </div>
  }
}


@connect(
  state => ({
    result: state.familyShareClass.result,
    searching: state.familyShareClass.loading,
    searched: state.familyShareClass.loaded,
    error: state.familyShareClass.error,
    sector: state.sector.result
  }),
  searchActions)

@CSSModules(Styles, {allowMultiple:true})
export default class Family extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
  }

  constructor(props) {
    super(props)
    const family = props.location.query.q || ''
    const familyConfig = config.familyFunds.find(
      f => f.name === family
    )
    //
    this.state = {
      page: 1,
      family,
      familyConfig: familyConfig,
      searchQuery: '',
      lastResult: null,
      funds: [],
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
    this.familyShareClasses(this.state.family, 1)
  }

  componentWillReceiveProps(props) {
    const family = props.location.query.q || ''

    if (family !== this.state.family) {
      this.familyShareClasses(family, 1)
      window.scroll(0, 0)

      const familyConfig = config.familyFunds.find(
        f => f.name === family
      )

      this.setState({
        page: 1,
        family,
        familyConfig,
        searchQuery: '',
        lastResult: null,
        funds: [],
      })
    } else if (props.result && this.state.lastResult !== props.result){
      this.setState({
        lastResult: props.result,
        funds: this.state.funds.concat(props.result)
      })
    }
  }

  getMoreFunds = () => {
    this.familyShareClasses(this.state.family, this.state.page+1)
  }

  familyShareClasses = (family,page) => {
    page = page || this.state.page
    this.setState({page:page})
    this.props.familyShareClasses(family, page)
  }

  //
  render() {
    // if we don't have a family name in the URL as a query,
    // show the generic grid of families
    if (!this.props.location.query.q) {
      return <div styleName='main'>
        <FamilyGrid fullGrid/>
      </div>
    }

    // if we're still loading the data from the API,
    // show a loading icon
    if (!(this.state.page !== 1 || !this.props.searching)) {
      return <div styleName='main'>
        <Loader options={{scale: 0.70, top:'2.0rem'}} loaded={false}/>
      </div>
    }

    const { funds, familyConfig } = this.state
    // const fundFamily = this.configFundFamily()

    // load a fund manager logo, if it has one
    const fileName = format.imgPath(this.state.family)
    let hasLogo = false
    let companyLogo = null
    try {
      companyLogo = require('../../../static/images/fam/'+fileName+'.png')
      hasLogo = true
    }
    catch (e) {
      console.log('')
    }

    const hasMore = (
      this.state.lastResult &&
      this.state.lastResult.length === config.queryMaxFunds
    )

    //
    return <div styleName='main'>
      {container.helmet(this.state.family || 'Fund managers')}


      <ContainerDivs>

        <header styleName='header'>

          <div styleName='header__name-tag'>
            Fund manager
          </div>

          {
            hasLogo ?
              <div styleName='header__name-logo-wrap'>
                <h1 styleName='header__name'>
                  {
                    familyConfig ?
                      familyConfig.label :
                      this.state.family
                  }
                </h1>
                <img
                  styleName='header__logo'
                  src={companyLogo}
                  alt={
                    familyConfig ?
                      familyConfig.label :
                      this.state.family
                  }
                />
               </div> :
              <h1 styleName='header__name'>{this.state.family}</h1>
          }
        </header>


        {/* <FamilyResults fundFamily={familyConfig} /> */}


        {/* THE TABLE OF FUNDS FROM THIS FUND MNANAGER */}
        <FundManagerFundList fundList={funds} />
 
 
        <div styleName='more-funds'>
          <Loader
            options={{scale: 0.70, top:'0'}}
            loaded={ !this.props.searching }
          />

          <div
            onClick={hasMore ? this.getMoreFunds : null}
            styleName={
              hasMore ? 'more-funds__button' : 'more-funds__button--disabled'
            }
          >
            {
              hasMore ?
                'Get more funds' :
                'No more funds'
            }<LinkIcon faclass='fa-plus-circle'/>
          </div>
          {
            !hasMore ?
              <div styleName='more-funds__disclaimer'>
                Looking for your favorite fund and can't find it? Sorry,
                but we don't have everything in our database.
              </div> :
              null
          }
        </div>


      </ContainerDivs>
    </div>
  }
}
